import Toolbar from "./toolbar.component";

export default Toolbar;
